export const Dollar = ({ width = 12, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M7.66667 3.86111H6M6 3.86111H5.16667C4.52233 3.86111 4 4.33992 4 4.93056C4 5.52119 4.52233 6 5.16667 6H6M6 3.86111V3.25M6 3.86111V6M6 6H6.83333C7.47767 6 8 6.47881 8 7.06944C8 7.66008 7.47767 8.13889 6.83333 8.13889H6M6 6V8.13889M6 8.13889H4M6 8.13889V8.75"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
